/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as BookRouteImport } from './routes/book'
import { Route as LoginRouteImport } from './routes/login'
import { Route as TournamentsRouteImport } from './routes/tournaments'
import { Route as AuthedAdminRouteImport } from './routes/_authed/_admin'
import { Route as AuthedCheckoutRouteImport } from './routes/_authed/checkout'
import { Route as AuthedMeRouteImport } from './routes/_authed/me'
import { Route as AuthedPackagesRouteImport } from './routes/_authed/packages'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as TSlugRouteImport } from './routes/t.$slug'
import { Route as AuthedBookingsIndexRouteImport } from './routes/_authed/bookings.index'
import { Route as AuthedPaymentsIndexRouteImport } from './routes/_authed/payments.index'
import { Route as AuthedRoundSlugRouteImport } from './routes/_authed/round.$slug'
import { Route as DevPayPaymentIdRouteImport } from './routes/dev/pay.$paymentId'
import { Route as AuthedAdminAdminIndexRouteImport } from './routes/_authed/_admin/admin.index'
import { Route as AuthedAdminAdminActivityRouteImport } from './routes/_authed/_admin/admin.activity'
import { Route as AuthedAdminAdminCalendarRouteImport } from './routes/_authed/_admin/admin.calendar'
import { Route as AuthedAdminAdminClosuresRouteImport } from './routes/_authed/_admin/admin.closures'
import { Route as AuthedAdminAdminCustomersRouteImport } from './routes/_authed/_admin/admin.customers'
import { Route as AuthedAdminAdminNewRouteImport } from './routes/_authed/_admin/admin.new'
import { Route as AuthedAdminAdminPaymentsRouteImport } from './routes/_authed/_admin/admin.payments'
import { Route as AuthedAdminAdminRatesRouteImport } from './routes/_authed/_admin/admin.rates'
import { Route as AuthedAdminAdminReportsRouteImport } from './routes/_authed/_admin/admin.reports'
import { Route as AuthedAdminAdminSettingsRouteImport } from './routes/_authed/_admin/admin.settings'
import { Route as AuthedAdminAdminTodayRouteImport } from './routes/_authed/_admin/admin.today'
import { Route as AuthedAdminAdminTournamentsRouteImport } from './routes/_authed/_admin/admin.tournaments'
import { Route as AuthedPaymentsPaymentIdRebookRouteImport } from './routes/_authed/payments.$paymentId.rebook'
import { Route as AuthedAdminAdminBookingBookingIdRouteImport } from './routes/_authed/_admin/admin.booking.$bookingId'
import { Route as AuthedAdminAdminCustomerUserIdRouteImport } from './routes/_authed/_admin/admin.customer.$userId'
import { Route as AuthedAdminAdminTournamentTournamentIdRouteImport } from './routes/_authed/_admin/admin.tournament.$tournamentId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const BookRoute = BookRouteImport.update({
  id: '/book',
  path: '/book',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const TournamentsRoute = TournamentsRouteImport.update({
  id: '/tournaments',
  path: '/tournaments',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCheckoutRoute = AuthedCheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeRoute = AuthedMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPackagesRoute = AuthedPackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const TSlugRoute = TSlugRouteImport.update({
  id: '/t/$slug',
  path: '/t/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedBookingsIndexRoute = AuthedBookingsIndexRouteImport.update({
  id: '/bookings/',
  path: '/bookings/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaymentsIndexRoute = AuthedPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRoundSlugRoute = AuthedRoundSlugRouteImport.update({
  id: '/round/$slug',
  path: '/round/$slug',
  getParentRoute: () => AuthedRoute,
} as any)
const DevPayPaymentIdRoute = DevPayPaymentIdRouteImport.update({
  id: '/dev/pay/$paymentId',
  path: '/dev/pay/$paymentId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAdminAdminIndexRoute = AuthedAdminAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAdminActivityRoute =
  AuthedAdminAdminActivityRouteImport.update({
    id: '/admin/activity',
    path: '/admin/activity',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminAdminCalendarRoute =
  AuthedAdminAdminCalendarRouteImport.update({
    id: '/admin/calendar',
    path: '/admin/calendar',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminAdminClosuresRoute =
  AuthedAdminAdminClosuresRouteImport.update({
    id: '/admin/closures',
    path: '/admin/closures',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminAdminCustomersRoute =
  AuthedAdminAdminCustomersRouteImport.update({
    id: '/admin/customers',
    path: '/admin/customers',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminAdminNewRoute = AuthedAdminAdminNewRouteImport.update({
  id: '/admin/new',
  path: '/admin/new',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAdminPaymentsRoute =
  AuthedAdminAdminPaymentsRouteImport.update({
    id: '/admin/payments',
    path: '/admin/payments',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminAdminRatesRoute = AuthedAdminAdminRatesRouteImport.update({
  id: '/admin/rates',
  path: '/admin/rates',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAdminReportsRoute = AuthedAdminAdminReportsRouteImport.update({
  id: '/admin/reports',
  path: '/admin/reports',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAdminSettingsRoute =
  AuthedAdminAdminSettingsRouteImport.update({
    id: '/admin/settings',
    path: '/admin/settings',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminAdminTodayRoute = AuthedAdminAdminTodayRouteImport.update({
  id: '/admin/today',
  path: '/admin/today',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminAdminTournamentsRoute =
  AuthedAdminAdminTournamentsRouteImport.update({
    id: '/admin/tournaments',
    path: '/admin/tournaments',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedPaymentsPaymentIdRebookRoute =
  AuthedPaymentsPaymentIdRebookRouteImport.update({
    id: '/payments/$paymentId/rebook',
    path: '/payments/$paymentId/rebook',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAdminAdminBookingBookingIdRoute =
  AuthedAdminAdminBookingBookingIdRouteImport.update({
    id: '/admin/booking/$bookingId',
    path: '/admin/booking/$bookingId',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminAdminCustomerUserIdRoute =
  AuthedAdminAdminCustomerUserIdRouteImport.update({
    id: '/admin/customer/$userId',
    path: '/admin/customer/$userId',
    getParentRoute: () => AuthedAdminRoute,
  } as any)
const AuthedAdminAdminTournamentTournamentIdRoute =
  AuthedAdminAdminTournamentTournamentIdRouteImport.update({
    id: '/admin/tournament/$tournamentId',
    path: '/admin/tournament/$tournamentId',
    getParentRoute: () => AuthedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/book': typeof BookRoute
  '/login': typeof LoginRoute
  '/tournaments': typeof TournamentsRoute
  '/checkout': typeof AuthedCheckoutRoute
  '/me': typeof AuthedMeRoute
  '/packages': typeof AuthedPackagesRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/t/$slug': typeof TSlugRoute
  '/round/$slug': typeof AuthedRoundSlugRoute
  '/dev/pay/$paymentId': typeof DevPayPaymentIdRoute
  '/bookings/': typeof AuthedBookingsIndexRoute
  '/payments/': typeof AuthedPaymentsIndexRoute
  '/admin/activity': typeof AuthedAdminAdminActivityRoute
  '/admin/calendar': typeof AuthedAdminAdminCalendarRoute
  '/admin/closures': typeof AuthedAdminAdminClosuresRoute
  '/admin/customers': typeof AuthedAdminAdminCustomersRoute
  '/admin/new': typeof AuthedAdminAdminNewRoute
  '/admin/payments': typeof AuthedAdminAdminPaymentsRoute
  '/admin/rates': typeof AuthedAdminAdminRatesRoute
  '/admin/reports': typeof AuthedAdminAdminReportsRoute
  '/admin/settings': typeof AuthedAdminAdminSettingsRoute
  '/admin/today': typeof AuthedAdminAdminTodayRoute
  '/admin/tournaments': typeof AuthedAdminAdminTournamentsRoute
  '/payments/$paymentId/rebook': typeof AuthedPaymentsPaymentIdRebookRoute
  '/admin/': typeof AuthedAdminAdminIndexRoute
  '/admin/booking/$bookingId': typeof AuthedAdminAdminBookingBookingIdRoute
  '/admin/customer/$userId': typeof AuthedAdminAdminCustomerUserIdRoute
  '/admin/tournament/$tournamentId': typeof AuthedAdminAdminTournamentTournamentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/book': typeof BookRoute
  '/login': typeof LoginRoute
  '/tournaments': typeof TournamentsRoute
  '/checkout': typeof AuthedCheckoutRoute
  '/me': typeof AuthedMeRoute
  '/packages': typeof AuthedPackagesRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/t/$slug': typeof TSlugRoute
  '/round/$slug': typeof AuthedRoundSlugRoute
  '/dev/pay/$paymentId': typeof DevPayPaymentIdRoute
  '/bookings': typeof AuthedBookingsIndexRoute
  '/payments': typeof AuthedPaymentsIndexRoute
  '/admin/activity': typeof AuthedAdminAdminActivityRoute
  '/admin/calendar': typeof AuthedAdminAdminCalendarRoute
  '/admin/closures': typeof AuthedAdminAdminClosuresRoute
  '/admin/customers': typeof AuthedAdminAdminCustomersRoute
  '/admin/new': typeof AuthedAdminAdminNewRoute
  '/admin/payments': typeof AuthedAdminAdminPaymentsRoute
  '/admin/rates': typeof AuthedAdminAdminRatesRoute
  '/admin/reports': typeof AuthedAdminAdminReportsRoute
  '/admin/settings': typeof AuthedAdminAdminSettingsRoute
  '/admin/today': typeof AuthedAdminAdminTodayRoute
  '/admin/tournaments': typeof AuthedAdminAdminTournamentsRoute
  '/payments/$paymentId/rebook': typeof AuthedPaymentsPaymentIdRebookRoute
  '/admin': typeof AuthedAdminAdminIndexRoute
  '/admin/booking/$bookingId': typeof AuthedAdminAdminBookingBookingIdRoute
  '/admin/customer/$userId': typeof AuthedAdminAdminCustomerUserIdRoute
  '/admin/tournament/$tournamentId': typeof AuthedAdminAdminTournamentTournamentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/book': typeof BookRoute
  '/login': typeof LoginRoute
  '/tournaments': typeof TournamentsRoute
  '/_authed/_admin': typeof AuthedAdminRouteWithChildren
  '/_authed/checkout': typeof AuthedCheckoutRoute
  '/_authed/me': typeof AuthedMeRoute
  '/_authed/packages': typeof AuthedPackagesRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/t/$slug': typeof TSlugRoute
  '/_authed/round/$slug': typeof AuthedRoundSlugRoute
  '/dev/pay/$paymentId': typeof DevPayPaymentIdRoute
  '/_authed/bookings/': typeof AuthedBookingsIndexRoute
  '/_authed/payments/': typeof AuthedPaymentsIndexRoute
  '/_authed/_admin/admin/activity': typeof AuthedAdminAdminActivityRoute
  '/_authed/_admin/admin/calendar': typeof AuthedAdminAdminCalendarRoute
  '/_authed/_admin/admin/closures': typeof AuthedAdminAdminClosuresRoute
  '/_authed/_admin/admin/customers': typeof AuthedAdminAdminCustomersRoute
  '/_authed/_admin/admin/new': typeof AuthedAdminAdminNewRoute
  '/_authed/_admin/admin/payments': typeof AuthedAdminAdminPaymentsRoute
  '/_authed/_admin/admin/rates': typeof AuthedAdminAdminRatesRoute
  '/_authed/_admin/admin/reports': typeof AuthedAdminAdminReportsRoute
  '/_authed/_admin/admin/settings': typeof AuthedAdminAdminSettingsRoute
  '/_authed/_admin/admin/today': typeof AuthedAdminAdminTodayRoute
  '/_authed/_admin/admin/tournaments': typeof AuthedAdminAdminTournamentsRoute
  '/_authed/payments/$paymentId/rebook': typeof AuthedPaymentsPaymentIdRebookRoute
  '/_authed/_admin/admin/': typeof AuthedAdminAdminIndexRoute
  '/_authed/_admin/admin/booking/$bookingId': typeof AuthedAdminAdminBookingBookingIdRoute
  '/_authed/_admin/admin/customer/$userId': typeof AuthedAdminAdminCustomerUserIdRoute
  '/_authed/_admin/admin/tournament/$tournamentId': typeof AuthedAdminAdminTournamentTournamentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/book'
    | '/login'
    | '/tournaments'
    | '/checkout'
    | '/me'
    | '/packages'
    | '/auth/callback'
    | '/t/$slug'
    | '/round/$slug'
    | '/dev/pay/$paymentId'
    | '/bookings/'
    | '/payments/'
    | '/admin/activity'
    | '/admin/calendar'
    | '/admin/closures'
    | '/admin/customers'
    | '/admin/new'
    | '/admin/payments'
    | '/admin/rates'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/today'
    | '/admin/tournaments'
    | '/payments/$paymentId/rebook'
    | '/admin/'
    | '/admin/booking/$bookingId'
    | '/admin/customer/$userId'
    | '/admin/tournament/$tournamentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/book'
    | '/login'
    | '/tournaments'
    | '/checkout'
    | '/me'
    | '/packages'
    | '/auth/callback'
    | '/t/$slug'
    | '/round/$slug'
    | '/dev/pay/$paymentId'
    | '/bookings'
    | '/payments'
    | '/admin/activity'
    | '/admin/calendar'
    | '/admin/closures'
    | '/admin/customers'
    | '/admin/new'
    | '/admin/payments'
    | '/admin/rates'
    | '/admin/reports'
    | '/admin/settings'
    | '/admin/today'
    | '/admin/tournaments'
    | '/payments/$paymentId/rebook'
    | '/admin'
    | '/admin/booking/$bookingId'
    | '/admin/customer/$userId'
    | '/admin/tournament/$tournamentId'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/book'
    | '/login'
    | '/tournaments'
    | '/_authed/_admin'
    | '/_authed/checkout'
    | '/_authed/me'
    | '/_authed/packages'
    | '/auth/callback'
    | '/t/$slug'
    | '/_authed/round/$slug'
    | '/dev/pay/$paymentId'
    | '/_authed/bookings/'
    | '/_authed/payments/'
    | '/_authed/_admin/admin/activity'
    | '/_authed/_admin/admin/calendar'
    | '/_authed/_admin/admin/closures'
    | '/_authed/_admin/admin/customers'
    | '/_authed/_admin/admin/new'
    | '/_authed/_admin/admin/payments'
    | '/_authed/_admin/admin/rates'
    | '/_authed/_admin/admin/reports'
    | '/_authed/_admin/admin/settings'
    | '/_authed/_admin/admin/today'
    | '/_authed/_admin/admin/tournaments'
    | '/_authed/payments/$paymentId/rebook'
    | '/_authed/_admin/admin/'
    | '/_authed/_admin/admin/booking/$bookingId'
    | '/_authed/_admin/admin/customer/$userId'
    | '/_authed/_admin/admin/tournament/$tournamentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  BookRoute: typeof BookRoute
  LoginRoute: typeof LoginRoute
  TournamentsRoute: typeof TournamentsRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  TSlugRoute: typeof TSlugRoute
  DevPayPaymentIdRoute: typeof DevPayPaymentIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/book': {
      id: '/book'
      path: '/book'
      fullPath: '/book'
      preLoaderRoute: typeof BookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournaments': {
      id: '/tournaments'
      path: '/tournaments'
      fullPath: '/tournaments'
      preLoaderRoute: typeof TournamentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/_admin': {
      id: '/_authed/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/checkout': {
      id: '/_authed/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof AuthedCheckoutRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/me': {
      id: '/_authed/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AuthedMeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/packages': {
      id: '/_authed/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof AuthedPackagesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/t/$slug': {
      id: '/t/$slug'
      path: '/t/$slug'
      fullPath: '/t/$slug'
      preLoaderRoute: typeof TSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/bookings/': {
      id: '/_authed/bookings/'
      path: '/bookings'
      fullPath: '/bookings/'
      preLoaderRoute: typeof AuthedBookingsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payments/': {
      id: '/_authed/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof AuthedPaymentsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/round/$slug': {
      id: '/_authed/round/$slug'
      path: '/round/$slug'
      fullPath: '/round/$slug'
      preLoaderRoute: typeof AuthedRoundSlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/dev/pay/$paymentId': {
      id: '/dev/pay/$paymentId'
      path: '/dev/pay/$paymentId'
      fullPath: '/dev/pay/$paymentId'
      preLoaderRoute: typeof DevPayPaymentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/_admin/admin/': {
      id: '/_authed/_admin/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/activity': {
      id: '/_authed/_admin/admin/activity'
      path: '/admin/activity'
      fullPath: '/admin/activity'
      preLoaderRoute: typeof AuthedAdminAdminActivityRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/calendar': {
      id: '/_authed/_admin/admin/calendar'
      path: '/admin/calendar'
      fullPath: '/admin/calendar'
      preLoaderRoute: typeof AuthedAdminAdminCalendarRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/closures': {
      id: '/_authed/_admin/admin/closures'
      path: '/admin/closures'
      fullPath: '/admin/closures'
      preLoaderRoute: typeof AuthedAdminAdminClosuresRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/customers': {
      id: '/_authed/_admin/admin/customers'
      path: '/admin/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AuthedAdminAdminCustomersRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/new': {
      id: '/_authed/_admin/admin/new'
      path: '/admin/new'
      fullPath: '/admin/new'
      preLoaderRoute: typeof AuthedAdminAdminNewRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/payments': {
      id: '/_authed/_admin/admin/payments'
      path: '/admin/payments'
      fullPath: '/admin/payments'
      preLoaderRoute: typeof AuthedAdminAdminPaymentsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/rates': {
      id: '/_authed/_admin/admin/rates'
      path: '/admin/rates'
      fullPath: '/admin/rates'
      preLoaderRoute: typeof AuthedAdminAdminRatesRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/reports': {
      id: '/_authed/_admin/admin/reports'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AuthedAdminAdminReportsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/settings': {
      id: '/_authed/_admin/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthedAdminAdminSettingsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/today': {
      id: '/_authed/_admin/admin/today'
      path: '/admin/today'
      fullPath: '/admin/today'
      preLoaderRoute: typeof AuthedAdminAdminTodayRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/tournaments': {
      id: '/_authed/_admin/admin/tournaments'
      path: '/admin/tournaments'
      fullPath: '/admin/tournaments'
      preLoaderRoute: typeof AuthedAdminAdminTournamentsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/payments/$paymentId/rebook': {
      id: '/_authed/payments/$paymentId/rebook'
      path: '/payments/$paymentId/rebook'
      fullPath: '/payments/$paymentId/rebook'
      preLoaderRoute: typeof AuthedPaymentsPaymentIdRebookRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/_admin/admin/booking/$bookingId': {
      id: '/_authed/_admin/admin/booking/$bookingId'
      path: '/admin/booking/$bookingId'
      fullPath: '/admin/booking/$bookingId'
      preLoaderRoute: typeof AuthedAdminAdminBookingBookingIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/customer/$userId': {
      id: '/_authed/_admin/admin/customer/$userId'
      path: '/admin/customer/$userId'
      fullPath: '/admin/customer/$userId'
      preLoaderRoute: typeof AuthedAdminAdminCustomerUserIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/_admin/admin/tournament/$tournamentId': {
      id: '/_authed/_admin/admin/tournament/$tournamentId'
      path: '/admin/tournament/$tournamentId'
      fullPath: '/admin/tournament/$tournamentId'
      preLoaderRoute: typeof AuthedAdminAdminTournamentTournamentIdRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
  }
}

interface AuthedAdminRouteChildren {
  AuthedAdminAdminActivityRoute: typeof AuthedAdminAdminActivityRoute
  AuthedAdminAdminCalendarRoute: typeof AuthedAdminAdminCalendarRoute
  AuthedAdminAdminClosuresRoute: typeof AuthedAdminAdminClosuresRoute
  AuthedAdminAdminCustomersRoute: typeof AuthedAdminAdminCustomersRoute
  AuthedAdminAdminNewRoute: typeof AuthedAdminAdminNewRoute
  AuthedAdminAdminPaymentsRoute: typeof AuthedAdminAdminPaymentsRoute
  AuthedAdminAdminRatesRoute: typeof AuthedAdminAdminRatesRoute
  AuthedAdminAdminReportsRoute: typeof AuthedAdminAdminReportsRoute
  AuthedAdminAdminSettingsRoute: typeof AuthedAdminAdminSettingsRoute
  AuthedAdminAdminTodayRoute: typeof AuthedAdminAdminTodayRoute
  AuthedAdminAdminTournamentsRoute: typeof AuthedAdminAdminTournamentsRoute
  AuthedAdminAdminIndexRoute: typeof AuthedAdminAdminIndexRoute
  AuthedAdminAdminBookingBookingIdRoute: typeof AuthedAdminAdminBookingBookingIdRoute
  AuthedAdminAdminCustomerUserIdRoute: typeof AuthedAdminAdminCustomerUserIdRoute
  AuthedAdminAdminTournamentTournamentIdRoute: typeof AuthedAdminAdminTournamentTournamentIdRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminAdminActivityRoute: AuthedAdminAdminActivityRoute,
  AuthedAdminAdminCalendarRoute: AuthedAdminAdminCalendarRoute,
  AuthedAdminAdminClosuresRoute: AuthedAdminAdminClosuresRoute,
  AuthedAdminAdminCustomersRoute: AuthedAdminAdminCustomersRoute,
  AuthedAdminAdminNewRoute: AuthedAdminAdminNewRoute,
  AuthedAdminAdminPaymentsRoute: AuthedAdminAdminPaymentsRoute,
  AuthedAdminAdminRatesRoute: AuthedAdminAdminRatesRoute,
  AuthedAdminAdminReportsRoute: AuthedAdminAdminReportsRoute,
  AuthedAdminAdminSettingsRoute: AuthedAdminAdminSettingsRoute,
  AuthedAdminAdminTodayRoute: AuthedAdminAdminTodayRoute,
  AuthedAdminAdminTournamentsRoute: AuthedAdminAdminTournamentsRoute,
  AuthedAdminAdminIndexRoute: AuthedAdminAdminIndexRoute,
  AuthedAdminAdminBookingBookingIdRoute: AuthedAdminAdminBookingBookingIdRoute,
  AuthedAdminAdminCustomerUserIdRoute: AuthedAdminAdminCustomerUserIdRoute,
  AuthedAdminAdminTournamentTournamentIdRoute:
    AuthedAdminAdminTournamentTournamentIdRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedCheckoutRoute: typeof AuthedCheckoutRoute
  AuthedMeRoute: typeof AuthedMeRoute
  AuthedPackagesRoute: typeof AuthedPackagesRoute
  AuthedRoundSlugRoute: typeof AuthedRoundSlugRoute
  AuthedBookingsIndexRoute: typeof AuthedBookingsIndexRoute
  AuthedPaymentsIndexRoute: typeof AuthedPaymentsIndexRoute
  AuthedPaymentsPaymentIdRebookRoute: typeof AuthedPaymentsPaymentIdRebookRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedCheckoutRoute: AuthedCheckoutRoute,
  AuthedMeRoute: AuthedMeRoute,
  AuthedPackagesRoute: AuthedPackagesRoute,
  AuthedRoundSlugRoute: AuthedRoundSlugRoute,
  AuthedBookingsIndexRoute: AuthedBookingsIndexRoute,
  AuthedPaymentsIndexRoute: AuthedPaymentsIndexRoute,
  AuthedPaymentsPaymentIdRebookRoute: AuthedPaymentsPaymentIdRebookRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  BookRoute: BookRoute,
  LoginRoute: LoginRoute,
  TournamentsRoute: TournamentsRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  TSlugRoute: TSlugRoute,
  DevPayPaymentIdRoute: DevPayPaymentIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
